import { ReactComponent as ClockLogo } from "../../img/icons/icon_clock.svg";
import SideNav from "../../components/sideNav";
import BottomNav from "../../components/bottomNav";
import { useHistory } from "react-router-dom";

const LandingPage = () => {
  const history = useHistory();

  return (
    <>
      <SideNav />
      <div className="body_content">
        <div className="inner_body py-5">
          <div className="w-100 icon_block d-flex justify-content-center mb-4">
            <ClockLogo className="img-fluid" />
          </div>
          <h3 className="text-center subtitle">
            Let us know about your health Information before doctor's
            consultation
          </h3>
          <h3 className="text-center subtitle">It will take 10-15 min.</h3>
          <div className="info_block d-flex justify-content-between w-100 align-items-center">
            <a href="#" className="link mb-0 mx-3 txt_color_orange">
              Ask me later
            </a>
            <div className="btn_block">
              <button
                className="btn btn_outline"
                onClick={() => history.push("health-info/start")}
              >
                Ok
              </button>
            </div>
          </div>
          <BottomNav />
        </div>
      </div>
    </>
  );
};

export default LandingPage;
